export const OW_FREE_TV_INSTALL_SKU = 'G2UTVINSTL';

export const OFFICEWORKS_FREE_TV_INSTALL_PARENT_ID = 25;
